import React from 'react';
import { Webform } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphWebform as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphWebformProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphWebform: React.FC<ParagraphWebformProps> = ({ entity }) => {
  const paragraphWebform = entity.toJS();
  const uuid = paragraphWebform.uuid[0].value;
  const { status, target_id: id } = paragraphWebform.field_webform[0];

  return (
    <div id={uuid} className="ParagraphWebform">
      <Container>
        <Webform id={id} status={status} />
      </Container>
    </div>
  );
};

export default ParagraphWebform;
